import React from 'react';
import { useParams, Routes, Route, Navigate,HashRouter  } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import TableListPage from './pages/TableListPage';
import Dashboard from "./pages/Dashboard"
import DetailsPage from './pages/DetailsPage';

import RemoteCheckIn from './pages/RemoteCheckIn';
import AutoCheckIn from './pages/AutoCheckin';

import AdhocTask from './adhoc/AdhocTask';

import MedicalAssistantDashboard from './pages/MedicalAssistantDashboard';

import AuthRoute from './components/AuthRoute';
import { useAuth } from './hooks/useAuth';
import CommonTask from './pages/CommonTask'
import Invitation from './pages/Invitation'
import GCalendar from "./components/GCalendar"
import ListEvent from "./components/ListEvent"
import Events from "./components/Events"
import Event2 from "./components/Event2"

import ReceiveCall from "./pages/ReceiveCall"
import NewAgent from "./components/NewAgent"
import MsgChat from "./pages/MsgChat"
import AppointmentReminderPersona from './AppointmentReminderPersona/AppointmentReminder';
import TestVoiceChat from './pages/TestVoiceChat';


function ConditionalRoute() {
  const { id } = useParams();
  if  (id == 'Auto Check-in')
    return (  
      <AuthRoute>     
        <AutoCheckIn /> 
      </AuthRoute>        
    );
  if  (id == 'Post-Discharge')
    return (  
      <AuthRoute>     
        <RemoteCheckIn /> 
      </AuthRoute>        
    );

  if  (id == 'Pre-screening' || id == 'Preliminary')
    return (  
      <AuthRoute>     
        <CommonTask /> 
      </AuthRoute>        
    );
  if  (id == 'Incoming Call' )
    return (  
      <AuthRoute>     
        <ReceiveCall/> 
      </AuthRoute>        
    );
  if  (id == 'Chatbot Invitation' )
    return (  
      <AuthRoute>     
        <Invitation/> 
      </AuthRoute>        
    );
  if (id == 'Appointment Reminder')
    return (
      <AuthRoute>
        <AppointmentReminderPersona />
      </AuthRoute>
    );
  if (id == 'Voice Chat')
    return (
      <AuthRoute>
        <TestVoiceChat />
      </AuthRoute>
    );  
  return (  
    <AuthRoute>     
      <AdhocTask /> 
    </AuthRoute>        
  );
}


function App() {
  const { loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/msgchat" element={<MsgChat />} />
      <Route 
        path="/tasks/list" 
        element={
          <AuthRoute>
            <Dashboard />
          </AuthRoute>
        } 
      />
      <Route 
        path="/tasks/new" 
        element={
          <AuthRoute>
            <MedicalAssistantDashboard />
          </AuthRoute>
        } 
      />
      <Route 
        path="/tasks/new/:id" 
        element={
          <ConditionalRoute/>            
        } 
      />

      <Route 
        path="/tasks/list/:id" 
        element={
          <AuthRoute>
            <DetailsPage />
          </AuthRoute>
        } 
      />

      <Route 
        path="/calendar" 
        element={
          <AuthRoute>
            <Event2 />
          </AuthRoute>
        } 
      />
     
     <Route 
        path="/newagent" 
        element={
          <AuthRoute>
            <NewAgent />
          </AuthRoute>
        } 
      />


      <Route path="/" element={<Navigate to="/tasks/list" replace />} />
    </Routes>
  );
}

export default App;